import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _invert from "lodash/invert";

var _externalCreditStatus, _externalCreditStatus2, _borrowerTypeName, _currencyName;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var EXTERNAL_CREDIT_TYPE = {
  external: 'external'
};
export var externalCreditTypeName = _defineProperty({}, EXTERNAL_CREDIT_TYPE.external, 'Ръчно въведен в системата');
export var externalCreditTypeNameSelect = Object.entries(_invert(externalCreditTypeName)).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      value = _ref2[1];

  return {
    label: label,
    value: value
  };
});
export var EXTERNAL_CREDIT_STATUS = {
  active: 'active',
  delayed: 'delayed',
  payed: 'payed'
};
export var externalCreditStatusName = (_externalCreditStatus = {}, _defineProperty(_externalCreditStatus, EXTERNAL_CREDIT_STATUS.active, 'Активен'), _defineProperty(_externalCreditStatus, EXTERNAL_CREDIT_STATUS.delayed, 'Просрочен'), _defineProperty(_externalCreditStatus, EXTERNAL_CREDIT_STATUS.payed, 'Погасен'), _externalCreditStatus);
export var externalCreditStatusColorMap = (_externalCreditStatus2 = {}, _defineProperty(_externalCreditStatus2, EXTERNAL_CREDIT_STATUS.active, 'success'), _defineProperty(_externalCreditStatus2, EXTERNAL_CREDIT_STATUS.delayed, 'error'), _defineProperty(_externalCreditStatus2, EXTERNAL_CREDIT_STATUS.payed, 'info'), _externalCreditStatus2);
export var externalCreditStatusNameSelect = Object.entries(_invert(externalCreditStatusName)).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      label = _ref4[0],
      value = _ref4[1];

  return {
    label: label,
    value: value
  };
});
export var BORROWER_TYPE = {
  natural_person: 'natural_person',
  legal_entity: 'legal_entity'
};
export var borrowerTypeName = (_borrowerTypeName = {}, _defineProperty(_borrowerTypeName, BORROWER_TYPE.natural_person, 'Физическо лице'), _defineProperty(_borrowerTypeName, BORROWER_TYPE.legal_entity, 'Юридическо лице'), _borrowerTypeName);
export var borrowerTypeNameSelect = Object.entries(_invert(borrowerTypeName)).map(function (_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      label = _ref6[0],
      value = _ref6[1];

  return {
    label: label,
    value: value
  };
});
export var CURRENCY = {
  bgn: 'BGN',
  eur: 'EUR',
  usd: 'USD'
};
export var currencyName = (_currencyName = {}, _defineProperty(_currencyName, CURRENCY.bgn, 'BGN'), _defineProperty(_currencyName, CURRENCY.eur, 'EUR'), _currencyName);
export var currencyNameSelect = Object.entries(_invert(currencyName)).map(function (_ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
      label = _ref8[0],
      value = _ref8[1];

  return {
    label: label,
    value: value
  };
});